import { motion } from "framer-motion";

const ease = [0.76, 0, 0.24, 1];
const fade = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease } },
};

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 lg:py-40 bg-cream"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-16">
        {/* Headline */}
        <motion.h2
          variants={fade}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="font-display font-light text-5xl md:text-7xl lg:text-8xl leading-[0.98] tracking-[-0.03em] text-ink max-w-5xl"
          style={{ fontVariationSettings: '"SOFT" 60' }}
        >
          An institute built on <span className="italic text-saffron">discipline</span>, honesty, and the <span className="italic">long road.</span>
        </motion.h2>

        {/* Two-col body */}
        <div className="mt-16 md:mt-20 grid grid-cols-12 gap-6 md:gap-14">
          <motion.div
            variants={fade}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className="col-span-12 md:col-span-6"
          >
            <p className="drop-cap text-lg md:text-[19px] leading-[1.75] text-ink/85 font-light">
              NavSankalpIAS is a mentorship-first UPSC institute founded on a single conviction — that Civil Services aspirants deserve honest guidance, structured strategy and a mentor who is present, not performative. We refuse the noise of shortcut promises. Instead, we offer a quiet, exacting apprenticeship in the art of preparing for one of India's hardest examinations.
            </p>
          </motion.div>

          <motion.div
            variants={fade}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className="col-span-12 md:col-span-6 space-y-6"
          >
            <p className="text-lg leading-[1.75] text-ink/80 font-light">
              Our work sits at the intersection of two disciplines — the rigour of academic preparation and the psychology of holding steady across a two-year marathon. Weekly targets, personalised roadmaps, honest doubt-clearing, evaluated answer writing — the machinery of a serious attempt.
            </p>
            <p className="text-lg leading-[1.75] text-ink/70 font-light italic">
              A new resolve, for a nation that reads its own future.
            </p>
          </motion.div>
        </div>

        {/* Stats strip */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease }}
          className="mt-20 md:mt-24 grid grid-cols-2 md:grid-cols-4 border-t border-b border-ink-15 divide-x divide-ink/15"
        >
          {[
            { k: "07+", v: "Years Mentoring" },
            { k: "1000+", v: "Aspirants Guided" },
            { k: "1:1", v: "Personal Attention" },
            { k: "100%", v: "Online Delivery" },
          ].map((s) => (
            <div key={s.v} className="p-6 md:p-8">
              <div
                className="font-display italic font-light text-4xl md:text-5xl text-saffron leading-none"
                style={{ fontVariationSettings: '"SOFT" 100' }}
              >
                {s.k}
              </div>
              <div className="text-[10px] tracking-[0.28em] uppercase text-ink/55 font-medium mt-3">{s.v}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
